import React from 'react';
import { FullListing } from '@th/shared/src/types/FullListing';

type Props = {
  listing: FullListing;
  bottomDivider: any;
};

export default function ListingOpenHouseSection({
  listing,
  bottomDivider,
}: Props) {
  if (!listing.hasOpenHouseInFuture()) return null;

  return (
    <div>
      <h3 className="mb-4">
        Open House{listing.openHouses.length === 1 ? '' : 's'}
      </h3>
      {listing.openHouses.map((openHouse, i) => {
        return (
          <p key={i}>
            <span>{openHouse.formattedDateAndTimeInterval()}</span>
          </p>
        );
      })}
      {bottomDivider}
    </div>
  );
}
